import {DocumentStoreApi} from '@/components/document/store';
import {DocumentModel, ModelCondition, ModelFactory, ModelEventHandler, ValueResolver, VisibilitySet} from '@/engine';

export const createConditionsReducer = (valueResolver: ValueResolver, visibilitySet: VisibilitySet) => {
  return (predicates: ModelCondition[]) =>
    !!predicates.length && predicates.every(predicate => predicate(valueResolver, visibilitySet)());
};

export const createValidationsReducer = (valueResolver: ValueResolver, visibilitySet: VisibilitySet) => {
  return <T>(validations: ModelFactory<T>[]) => validations.map(validation => validation(valueResolver, visibilitySet));
};

export const createEvents = (
  store: DocumentStoreApi,
  valueResolver: ValueResolver,
  visibilitySet: VisibilitySet,
  documentModel?: DocumentModel,
) => {
  return (events: ModelEventHandler[]) =>
    events.map(event => event(store, valueResolver, visibilitySet, documentModel));
};
